import { Navigate } from 'react-router-dom';
import { useQuery } from 'convex/react';
import { api } from './convex/_generated/api';

export default function ProtectedRoute({ children }) {
  const sessionId = localStorage.getItem('session_id');
  
  const user = useQuery(api.users.getUserBySession,
    sessionId ? { sessionId } : "skip"
  );

  // still loading
  if (user === undefined) return null;

  // no session or expired
  if (!user) return <Navigate to="/" />;

  return children;
}